module.exports = __webpack_public_path__ + "static/media/banner.244ace95.png";